export const plannablesCacheKeys = {
  plannableStats: {
    all: (queryParams = {}) => ['plannableStats', queryParams] as const
  }
}
